import Image1 from "../../assets/images/factory4.jpg";
import Image2 from "../../assets/images/factory3.jpg";
import HeaderImage from "../../assets/images/main_header.jpg";
import {Breadcrumb, Button, Image} from "antd";
import {Link} from "react-router-dom";
import {FilePdfOutlined} from "@ant-design/icons";
import TY081130_003File from "../../assets/files/ТУ 08.11.30-003.pdf";


const images = [
    { id: 1, src: Image1, alt: "МТП-1 вид 1" },
    { id: 2, src: Image2, alt: "МТП-1 вид 2" },
];


const KormovoyMel = () => {


    return(
        <div className={"product-container"}>
            <div className={"product-container-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className={"product-header"}>
                <h1>Кормовой мел</h1>
                <Breadcrumb className="product-header-breadcrumb"
                            items={[
                                {
                                    title: <Link to="/">Главная страница</Link>
                                },
                                {
                                    title: <Link to="/productions">Продукция</Link>
                                },
                                {
                                    title: <span>Мел, сырье для производства комбикормов</span>,
                                },
                            ]}
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"product-content"}>
                <div className={"product-content-image-column"}>
                    <Button
                        type="primary"
                        icon={<FilePdfOutlined/>}
                        size="large"
                        onClick={() => window.open(TY081130_003File, "_blank", "noopener,noreferrer")}
                        className="pp-pdf-button"
                    >
                        Посмотреть ТУ
                    </Button>

                    <div className="images-grid">
                        {images.map((image) => (
                            <div className="image-wrapper" key={image.id}>
                                <Image
                                    src={image.src}
                                    alt={image.alt}
                                    className="pp-image"
                                    preview={{
                                        src: image.src,
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                </div>


                <div className={"product-content-text-column"}>
                    <div className={"product-content-text-column"}>
                        <div className={"product-content-description"}>
                            <h2>Описание продукта</h2>
                            <p>
                                Природный минеральный продукт,
                                получаемый путем дробления, сушки и последующего измельчения мягкой известняковой
                                породы. Он представляет собой однородный сыпучий порошок белого цвета, не содержащий
                                посторонних примесей, следов плесени и затхлого запаха.
                            </p>
                            <p>
                                Продукт разработан в соответствии с требованиями ГОСТ 17498 и технических условий ТУ
                                08.11.30-003-88724763-2023 и предназначен для использования в качестве ценного сырья при
                                производстве комбикормов и кормовых добавок для сельскохозяйственных животных и птицы.
                            </p>

                            <h3>Основные характеристики:</h3>
                            <ul>
                                <li><strong>Высокое содержание кальция:</strong> Массовая доля кальция составляет не
                                    менее 32%, что необходимо для формирования костной ткани и скорлупы яиц.
                                </li>
                                <li><strong>Низкая влажность:</strong> Содержание влаги не превышает 10%, что
                                    обеспечивает хорошую сыпучесть и предотвращает слеживание.
                                </li>
                                <li><strong>Чистота продукта:</strong> Строго контролируется содержание токсичных
                                    элементов (свинец, кадмий, ртуть, мышьяк) и радионуклидов, что гарантирует
                                    безопасность для здоровья животных.
                                </li>
                                <li><strong>Отсутствие металлических примесей:</strong> Не допускается наличие
                                    металлических частиц с острыми краями и частиц крупнее 2 мм.
                                </li>
                                <li><strong>Класс опасности:</strong> 4-й (малоопасное вещество), продукт нетоксичен,
                                    пожаро- и взрывобезопасен.
                                </li>
                            </ul>

                            <h3>Области применения:</h3>
                            <ul>
                                <li><strong>Производство комбикормов:</strong> В качестве минеральной добавки для
                                    балансирования рационов по кальцию.
                                </li>
                                <li><strong>Кормовые добавки:</strong> Используется как самостоятельный источник кальция
                                    для всех видов сельскохозяйственных животных и птицы.
                                </li>
                                <li><strong>Птицеводство:</strong> Незаменим для формирования прочной скорлупы яиц у
                                    кур-несушек.
                                </li>
                                <li><strong>Животноводство:</strong> Способствует правильному росту скелета у молодняка
                                    крупного рогатого скота, свиней и других животных.
                                </li>
                            </ul>

                            <h3>Преимущества:</h3>
                            <ul>
                                <li><strong>Природное происхождение:</strong> Продукт изготавливается из натурального
                                    сырья, добываемого на месторождении «Мирское», что гарантирует его экологическую
                                    чистоту.
                                </li>
                                <li><strong>Экономическая эффективность:</strong> Является доступным и эффективным
                                    источником кальция, позволяя снизить себестоимость готовых кормов.
                                </li>
                                <li><strong>Безопасность:</strong> Проходит строгий контроль на содержание токсичных
                                    элементов и радионуклидов (подтверждено Экспертным заключением ФБУ «Брянский ЦСМ»).
                                </li>
                                <li><strong>Удобство логистики:</strong> Поставляется как в упаковке (биг-беги от 400 до
                                    1200 кг, полипропиленовые или бумажные мешки), так и насыпью (навалом) в
                                    железнодорожных вагонах или автотранспорте.
                                </li>
                                <li><strong>Длительный срок хранения:</strong> Гарантийный срок хранения составляет 1
                                    год в сухих, чистых, хорошо вентилируемых помещениях.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


}

export default KormovoyMel;